import React from 'react';
import { graphql } from 'gatsby';

import { useTranslate } from 'gatsby-theme-soluble-source';
import FormSectionDS from 'design-system/src/components/organisms/FormSection';

export default function FormSection({ showContact, ...props }: any) {
    const _ = useTranslate();

    const translations = {
        address: _['footer.address']?.html,
        twitterUrl: _['global.twitter']?.text,
        linkedinUrl: _['global.linkedin']?.text,
        youtubeUrl: _['global.youtube']?.text,
        instagramUrl: _['global.instagram']?.text,
    };

    return <FormSectionDS {...(!!showContact && translations)} {...props} />;
}

export const query = graphql`
    fragment DatoCmsFormSection on DatoCmsFormSection {
        title
        titleTag
        text
        showContact
        form {
            ...Form
        }
    }
`;
